<template></template>

<script>
import { db } from '@/firebase';
import moment from 'moment'
export default {
    props: {
        id: String
    },

    data() {
        return {
            empresa: {
                nombre: "",
                sector: "",
                actividad: "",
                claseRiesgo: [],
                nit: "",
                centroTrabajo: "",
                direccion: "",
                ubicacion: {
                    pais: "",
                    departamento: "",
                    ciudad: "",
                },
                numeroTrabajadores: "",
                fechaActualizacion: "",
                responsable: "",
                esBaja: null,
                visita: "",
                evaluacion: "",
            },
            matriz: [],
        }
    },

    async created() {
        this.$isLoading(true)
        await this.obtenerEmpresa()
        await this.preObtenerMatriz();
        this.$isLoading(false)
    },

    methods: {
        async obtenerEmpresa() {
            console.log('id', this.id);
            await db.collection("cliente_empresa").doc(this.id).get().then((doc) => {
                if (doc.exists) {
                    (async () => {
                        let actividad = doc.data().em_actividad;
                        if (!actividad) {
                            actividad = doc.data().em_sector;
                        }
                        let visita = null;
                        if (!doc.data().em_registrado_por) {
                            visita = "IPER ANTIGUO"
                        } else {
                            visita = await this.obtenerUsuario(doc.data().em_registrado_por)
                        }
                        let claseRiesgo = []
                        if (doc.data().em_clase_riesgo) {
                            claseRiesgo.push(doc.data().em_clase_riesgo);
                        }
                        if (doc.data().em_clase_riesgo1) {
                            claseRiesgo.push(doc.data().em_clase_riesgo1);
                        }
                        if (doc.data().em_clase_riesgo2) {
                            claseRiesgo.push(doc.data().em_clase_riesgo2);
                        }
                        if (doc.data().em_clase_riesgo3) {
                            claseRiesgo.push(doc.data().em_clase_riesgo3);
                        }
                        if (doc.data().em_clase_riesgo4) {
                            claseRiesgo.push(doc.data().em_clase_riesgo4);
                        }
                        this.empresa = {
                            nombre: doc.data().em_empresa,
                            sector: doc.data().em_sector,
                            actividad: actividad,
                            claseRiesgo: claseRiesgo,
                            nit: doc.data().em_nit,
                            centroTrabajo: doc.data().em_trabajo,
                            direccion: doc.data().em_direccion,
                            ubicacion: {
                                pais: doc.data().em_pais,
                                departamento: doc.data().em_departamento,
                                ciudad: doc.data().em_ciudad,
                            },
                            numeroTrabajadores: doc.data().em_num_trabajadores,
                            fechaActualizacion: moment(doc.data().em_fecha_editado.toDate()).format("DD/MM/YYYY"),
                            responsable: doc.data().em_responsable,
                            esBaja: doc.data().em_baja,
                            visita: visita,
                            evaluacion: doc.data().em_evaluacion,
                            direccion: doc.data().em_direccion,
                        }
                    })()
                }
            });
        },

        async obtenerUsuario(correo) {
            let usuario = correo
            await db.collection("usuarios").where("u_correo", "==", correo).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    if (correo.includes("@sofu")) {
                        usuario = "SOFU BIC S.A.S"
                    } else {
                        usuario = `${doc.data().u_nombre_usuario} ${doc.data().u_apellido}`
                    }
                });
            })
            console.log(usuario);
            return usuario;
        },

        async preObtenerMatriz() {
            let procesos = await this.obtenerProcesos()
            let zonas = await this.obtenerZonas()
            let actividades = await this.obtenerActividades()
            let tareas = await this.obtenerTareas()
            await Promise.all(
                tareas.map(async (item) => {
                    return await this.obtenerMatriz(item, procesos, zonas, actividades)
                })
            );
            this.$emit("matriz", {
                empresa: this.empresa,
                matriz: this.matriz
            });
        },

        async obtenerProcesos() {
            let traerProcesos = db
                .collection("proceso")
                .where("em_id_cliente", "==", this.id)
                .get()
                .then((querySnapshot) => {
                    let arrayExcelProcesos = [];
                    if (querySnapshot.docs.length > 0) {
                        querySnapshot.forEach((doc) => {
                            arrayExcelProcesos.push({
                                id_proceso: doc.id,
                                em_proceso_riesgo: doc.data().em_proceso_riesgo,
                            });
                        });
                        return arrayExcelProcesos;
                    }
                    return arrayExcelProcesos;
                });
            return traerProcesos;
        },

        async obtenerZonas() {
            let traerZonas = db
                .collection("zona")
                .where("em_id_cliente", "==", this.id)
                .get()
                .then((querySnapshot) => {
                    let arrayExcelZonas = [];
                    if (querySnapshot.docs.length > 0) {
                        querySnapshot.forEach((doc) => {
                            arrayExcelZonas.push({
                                id_proceso: doc.data().em_id_proceso,
                                id_zona: doc.id,
                                em_zona: doc.data().em_zona,
                            });
                        });
                        return arrayExcelZonas;
                    }
                    return arrayExcelZonas;
                });
            return traerZonas;
        },

        async obtenerActividades() {
            let traerActividades = db
                .collection("actividades")
                .where("em_id_cliente", "==", this.id)
                .get()
                .then((querySnapshot) => {
                    let arrayExcelActividades = [];
                    if (querySnapshot.docs.length > 0) {
                        querySnapshot.forEach((doc) => {
                            arrayExcelActividades.push({
                                id_proceso: doc.data().em_id_proceso,
                                id_zona: doc.data().em_id_zona,
                                id_actividad: doc.id,
                                em_actividades: doc.data().em_actividades,
                            });
                        });
                        return arrayExcelActividades;
                    }
                    return arrayExcelActividades;
                });
            return traerActividades;
        },

        async obtenerTareas() {
            let traerTarea = db
                .collection("tareas")
                .where("em_id_cliente", "==", this.id)
                .get()
                .then((querySnapshot) => {
                    let arrayExcelTareas = [];
                    if (querySnapshot.docs.length > 0) {
                        querySnapshot.forEach((doc) => {
                            arrayExcelTareas.push({
                                id_proceso: doc.data().em_id_proceso,
                                id_zona: doc.data().em_id_zona,
                                id_actividad: doc.data().em_id_acti,
                                id_tarea: doc.id,
                                em_tareas: doc.data().em_tareas,
                            });
                            return arrayExcelTareas;
                        });
                    }
                    return arrayExcelTareas;
                });
            return traerTarea;
        },

        async obtenerMatriz(tarea, procesosArray, zonasArray, actividadesArray) {
            db.collection("matriz_riesgo").where("em_id_tareas", "==", tarea.id_tarea).get().then((querySnapshot) => {
                if (querySnapshot.docs.length > 0) {
                    querySnapshot.forEach((doc) => {
                        let subti = "";
                        let otro_subti = "";
                        let eliminacion = "";
                        let sustitucion = "";
                        let controles_ing = "";
                        let controles = "";
                        let equipos = "";
                        if (doc.data().em_subti) {
                            subti = doc.data().em_subti;
                        }
                        if (doc.data().em_otro_subti) {
                            otro_subti = doc.data().em_otro_subti;
                        }
                        if (doc.data().em_eliminacion) {
                            eliminacion = doc.data().em_eliminacion;
                        }
                        if (doc.data().em_sustitucion) {
                            sustitucion = doc.data().em_sustitucion;
                        }
                        if (doc.data().em_controles_ing) {
                            controles_ing = doc.data().em_controles_ing;
                        } else if (doc.data().em_control_ingenieria) {
                            controles_ing = doc.data().em_control_ingenieria;
                        }
                        if (doc.data().em_controles) {
                            controles = doc.data().em_controles;
                        } else if (doc.data().em_controles_admin) {
                            controles = doc.data().em_controles_admin;
                        }
                        if (doc.data().em_equipos) {
                            equipos = doc.data().em_equipos;
                        } else if (doc.data().em_epp) {
                            equipos = doc.data().em_epp;
                        }
                        let id_proceso = tarea.id_proceso;
                        let proceso_riesgo = "";
                        procesosArray.forEach((proceso) => {
                            if (proceso.id_proceso == id_proceso) {
                                proceso_riesgo = proceso.em_proceso_riesgo;
                            }
                        });
                        let id_zona = tarea.id_zona;
                        let zona = "";
                        zonasArray.forEach((zona_q) => {
                            if (zona_q.id_zona == id_zona) {
                                zona = zona_q.em_zona;
                            }
                        });
                        let id_acti = tarea.id_actividad;
                        let actividades = "";
                        actividadesArray.forEach((actividad) => {
                            if (actividad.id_actividad == id_acti) {
                                actividades = actividad.em_actividades;
                            }
                        });
                        let id_tareas = tarea.id_tarea;
                        let tareas = tarea.em_tareas;
                        this.matriz.unshift({
                            proceso_riesgo: proceso_riesgo,
                            id_proceso: id_proceso,
                            zona: zona,
                            id_zona: id_zona,
                            actividades: actividades,
                            id_acti: id_acti,
                            tareas: tareas,
                            id_tareas: id_tareas,
                            id_peligro: doc.data().em_id_peligro,
                            id_subcla: doc.data().em_id_subclasificacion,
                            id_efectos_posibles: doc.data().em_id_efectos_posibles,
                            descripcion: `${doc.data().em_descripcion}`,
                            clasificacion: `${doc.data().em_clasificacion}`,
                            tipo: `${doc.data().em_tipo}`,
                            rutinario: doc.data().em_rutinario,
                            subti: subti,
                            otro_subti: otro_subti,
                            efectos: doc.data().em_efecto_posible,
                            control_fuente: doc.data().em_c_fuente,
                            control_medio: doc.data().em_c_medio,
                            control_individuo: doc.data().em_c_individuo,
                            em_antecedente: doc.data().em_antecedente,
                            em_requisito_legal: doc.data().em_requisito_legal,
                            nivel_eficiencia: doc.data().em_nivel_eficiencia,
                            nivel_exposicion: doc.data().em_nivel_exposicion,
                            nivel_probabilidad: doc.data().em_nivel_probabilidad,
                            interpretacion: `${doc.data().em_interpretacion}`,
                            nivel_consecuencia: doc.data().em_nivel_consecuencia,
                            nivel_riesgo: doc.data().em_nivel_riesgo,
                            interpretacion_nr: `${doc.data().em_interpretacion_nr}`,
                            aceptabilidad: `${doc.data().em_aceptabilidad}`,
                            num_expuestos: doc.data().em_num_expuestos,
                            peor_consecuencia: `${doc.data().em_peor_consecuencia}`,
                            eliminacion: eliminacion,
                            sustitucion: sustitucion,
                            controles_ing: controles_ing,
                            controles: controles,
                            equipos: equipos,
                        });
                    })
                }
            })
        },
    }
}
</script>